import { render, staticRenderFns } from "./ReadDrawer.vue?vue&type=template&id=0bc41b02&scoped=true"
import script from "./ReadDrawer.vue?vue&type=script&lang=js"
export * from "./ReadDrawer.vue?vue&type=script&lang=js"
import style0 from "./ReadDrawer.vue?vue&type=style&index=0&id=0bc41b02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc41b02",
  null
  
)

export default component.exports